import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import TopBar from "../../components/TopBar";
import Footer from "../../components/Footer";
import Product from "../../components/home/Product";
import More from "../about/components/more";
import { useNavigate } from "react-router";
import PlayModal from "../../components/playModal";
import { useSelector } from "react-redux";
import { addOrder, deleteShoppingCart, shoppingCart, updateShoppingCart } from "../../API/card";
import { message } from "antd";
import { scrollToTop, showLoding } from "../../utils/tool";

const ComponentName: React.FC = () => {
  const { t } = useTranslation();
  const [see, setSee] = React.useState(false)
  const navigate = useNavigate()
  const [isShow, setIsShow] = React.useState(false)
  const token = useSelector((state: any) => state?.token)
  useEffect(() => {
    if (!!token) {
      handleLoad()
    }
  }, [token])

  const [cardLi, setCardLi]: any = React.useState([])
  const [cardInfo, setCardInfo] = React.useState<any>()
  const handleLoad = () => {
    shoppingCart().then((res: any) => {
      setCardLi(res.data?.items)
      setCardInfo(res.data)
    }).catch((err: any) => {
      console.log(err)
    })
  }

  const handleUpCard = (num: any, id: any, sizeId: any) => {
    showLoding(true)
    updateShoppingCart({
      id,
      productNum: Number(num),
      // sizeId
    }).then((res: any) => {
      handleLoad()
      message.success('修改成功')
      setTimeout(() => { 
        childRef.current?.handleCard();
      }, 600)
    }).catch((err: any) => {
      console.log(err)
    }).finally(() => {
      showLoding(false)
    })
  }

  const handleDelCard = (id: any) => {
    showLoding(true)
    deleteShoppingCart(id).then((res: any) => {
      handleLoad()
      message.success('刪除成功')
      setTimeout(() => { 
        childRef.current?.handleCard();
      }, 600)
    }).catch((err: any) => {
      console.log(err)
    }).finally(() => {
      showLoding(false)
    })
  }
  const childRef: any = useRef(null);


  const handleaddOrder = (password: string) => {
    showLoding(true)
    let itemsId: any = []
    cardLi.map((item: any) => {
      itemsId.push(item.id)
    })
    addOrder({
      "itemsId": itemsId,
      "password": btoa((password || '').trim()),
      addressId: cardInfo?.address?.id
    }).then((res: any) => {
      message.success('訂單建立成功')
      setIsShow(false)
      handleLoad()
      setTimeout(() => {
        childRef.current?.handleCard();
      }, 600)
      scrollToTop()
    }).catch((err: any) => {
      console.log(err)
    }).finally(() => {
      showLoding(false)
    })
  }

  return (
    <div className="">
      <TopBar ref={childRef} />
      <div className=" w-[1200px] mx-auto h5:w-full">
        <div className="my-[30px] flex items-center text-[#181512] text-[16px] h5:px-16">
          <div className="text-[#595959] text-[16px] mr-4 cursor-pointer" onClick={() => navigate('/')}>首頁</div>
          /
          <div className="text-[#181512] text-[16px] ml-4">購物車</div>
        </div>
        <br />

        <div className="text-[#181512] text-[44px] font-bold text-center h5:px-16">購物車</div>

        <div className="w-[1200px] mx-auto h5:w-full">
          <div className="h5:w-[100vw] h5:overflow-x-auto">
            <div className="flex py-[30px] mb-[0px] h5:min-w-[1000px]"
              style={{
                borderBottom: "1px solid #cfc8d8",
              }}>
              <div className="w-[317px] h5:min-w-[22px]"></div>
              <div className="text-[#181512] text-[16px] w-[468px] font-bold">商品</div>
              <div className="text-[#181512] text-[16px] w-[144px] font-bold">	價格</div>
              <div className="text-[#181512] text-[16px] w-[127px] font-bold">數量</div>
              <div className="text-[#181512] text-[16px] w-[144px] font-bold">小計</div>
            </div>
            <div className=" py-[30px] mb-[30px] h5:pt-20 h5:pb-[16px] h5:mb-0 h5:min-w-[1000px] h5:px-16"
              style={{
                borderBottom: "1px solid #cfc8d8",
              }}>
              {
                cardLi && cardLi.length > 0 ? cardLi.map((item: any, index: React.Key | null | undefined) => (
                  <div className="flex items-center pb-[10px] cursor-pointer h5:min-w-[1000px]" key={index}
                    onClick={() => {
                      navigate(`/product?id=${item?.productDetail?.id}&category=${'精選商品'}`)
                    }
                    }>
                    <div className="flex-1">
                      <img src={require("../../assets/image/close.png")}
                        onClick={(e) => {
                          e.stopPropagation()
                          handleDelCard(item?.id)
                        }}
                        className="w-[22px] h-[22px] mx-auto object-cover h5:min-w-[22px]" alt="" />
                    </div>
                    <div className="w-[234px]">
                      <img src={item?.productDetail?.imageUrl}
                        className="w-[68px] h-[68px] mx-auto object-cover" alt="" />
                    </div>
                    <div className="text-[#595959] text-[16px] w-[468px] font-bold pt-[12px] line-clamp-1">
                      {item?.productDetail?.title}
                    </div>
                    <div className="text-[#595959] text-[16px] w-[144px] pt-[12px] font-bold">USD{item?.productDetail?.originalPrice}</div>
                    <div className="text-[#595959] text-[16px] w-[127px] font-bold">
                      <input type="number" className="w-[55px] h-[55px] p-1 rounded-sm text-center focus:outline-none"
                        value={item?.productNum}
                        onChange={(e: any) => {
                          let _num = e.target.value
                          if (_num <= 0) {
                            _num = 1
                          }
                          handleUpCard(_num, item?.id, item?.sizeId)
                        }} 
                        style={{
                          border: '1px solid rgba(0, 0, 0, .2)'
                        }} />
                    </div>
                    <div className="text-[#595959] text-[16px] w-[144px] pt-[12px] font-bold">	USD{item?.productDetail?.currentPrice}</div>
                  </div>
                ))
                  :
                  <div className="text-[#595959] text-[16px] text-center">暫無商品，快點去
                    <span className="text-[#2d634e] font-bold cursor-pointer underline px-4"
                      onClick={() => navigate('/category')}>添加</span>
                    吧</div>
              }
            </div>
          </div>

          <div className="pb-[100px] h5:pt-[50px]">
            <div className="flex h5:px-16">
              <div className="flex-1 h5:hidden"></div>
              <div className="flex-1">
                <div className="text-[#181512] text-[30px] pb-10 mb-10"
                  style={{
                    borderBottom: "1px solid #cfc8d8",
                  }}>購物車總計</div>
                <div className="text-[#181512] text-[18px] flex items-center mb-20">
                  <div className=" text-[#181512] text-[18px] w-[180px] h5:w-[100px]">小計</div>
                  <div className=" text-[#181512] text-[18px]">USD{cardInfo?.totalOriginalPrice}</div>
                </div>
                <div className="text-[#181512] text-[18px] flex items-center mb-20">
                  <div className=" text-[#181512] text-[18px] w-[180px] h5:w-[100px]">滿萬送千</div>
                  <div className=" text-[#181512] text-[18px]">-USD{cardInfo?.discountAmount}</div>
                </div>
                <div className="text-[#181512] text-[18px] flex items-start mb-20 hidden">
                  <div className=" text-[#181512] text-[18px] w-[180px] h5:w-[100px]">運送方式</div>
                  <div className=" text-[#181512] text-[18px] flex-1">
                    運送至
                    {cardInfo?.address?.country}, {cardInfo?.address?.city}, {cardInfo?.address?.district} {cardInfo?.address?.streetAddress}
                    <div className="flex text-[#2d634e] text-[18px] font-bold cursor-pointer underline"
                      onClick={() => navigate("/account?tab=4")}>
                      變更地址
                    </div>
                  </div>
                </div> 
                <div className="text-[#181512] text-[18px] flex items-center mb-[20px]">
                  <div className=" text-[#181512] text-[18px] w-[180px] font-bold h5:w-[100px]">總計</div>
                  <div className=" text-[#181512] text-[18px] font-bold">USD {cardInfo?.totalCurrentPrice}</div>
                </div>
                <div className="text-[#181512] text-[18px] flex items-center mb-[50px]">
                  <div className=" text-[#181512] text-[18px] w-[180px] font-bold h5:w-[100px]">錢包餘額</div>
                  <div className=" text-[#181512] text-[18px] font-bold">USD {cardInfo?.walletBalance}</div>
                </div>
                <div className="bg-[#595959] rounded-[4px] flex items-center justify-center py-[18px] text-[#fff] 
                    text-[18px] cursor-pointer
                    hover:bg-[#000] mt-[30px] font-bold"
                  onClick={() => {
                    if (Number(cardInfo?.walletBalance) < 0) {
                      message.error("錢包餘額不足")
                      return
                    }
                    setIsShow(true)
                  }}>
                  前往結賬 ＞
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <PlayModal isShow={isShow}
        productTitle='購物車總計'
        purchaseQuantity={cardInfo?.totalCurrentPrice}
        onChange={() => {
          setIsShow(false)
        }}
        onConfirm={(e: string) => {
          handleaddOrder(e)
        }}
      />
      <Footer />
    </div>
  );
};

export default ComponentName;
